// Variant selector
class VariantSelector extends HTMLElement {
    constructor() {
        super();
        this.cached = {};
        this.container = this.closest("#product-form");
        this.addEventListener("change", this.onVariantChange);
    }

    onVariantChange() {
        this.getSelectedOptions();
        this.getSelectedVariant();

        if (this.currentVariant) {
            this.updateURL();
            if (this.dataset.imageVariant) {
                this.updateImagesVariant();
            } else {
                this.updateMedia();
            }
            this.variantFetch();
        }
    }

    getSelectedOptions() {
        this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
        // console.log(this.options);
    }

    getVariantJSON() {
        this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    getSelectedVariant() {
        this.currentVariant = this.getVariantJSON().find((variant) => {
            const findings = !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);

            if (findings) return variant;
        });
    }

    updateURL() {
        window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    variantFetch() {
        var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

        if (this.cached[variantUrl]) {
            this.renderVariantInfo(this.cached[variantUrl]);
            return;
        }

        fetch(variantUrl)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, "text/html");
                this.cached[variantUrl] = html;
                this.renderVariantInfo(html);
            })
            .catch((e) => {
                console.error(e);
            });
    }

    renderVariantInfo(html) {
        this.updateElementOuter("#product_id", html);
        this.updateElementOuter(".mm-selected-variant-desc", html);
        this.updateElementOuter(".mm-selected-variant-sub", html);
        this.updateElementOuter(".mm-product-form-variant", html);
        this.updatePriceLine(html);
        this.updateElementOuter(".mm-product-shipping-block", html);
        this.updateElementOuter(".mm-product-cta-wrapper", html);
        this.updateElementOuter(".mm-product-helper", html);
        this.updateImagesVariant();
    }

    updatePriceLine(html) {
        const destination =
            this.container.querySelector(".mm-product-price-line[data-mm-price-root]") ||
            this.container.querySelector("[data-mm-price-root]:not([data-hv-dynamic-price])");
        const source =
            html.querySelector(".mm-product-price-line[data-mm-price-root]") ||
            html.querySelector("[data-mm-price-root]:not([data-hv-dynamic-price])");

        if (!source || !destination) return;

        destination.innerHTML = source.innerHTML;

        const mmMulti = this.container.querySelector("mm-multiple-custom-v2");
        if (mmMulti && typeof mmMulti.snapshotPrices === "function") {
            mmMulti.snapshotPrices();
        }
    }

    /**
     *
     * @param {string} selector
     * @param {HtmlElement} html
     */
    updateElement(selector, html) {
        const destination = this.container.querySelector(selector);
        const source = html.querySelector(selector);
        if (source && destination) destination.innerHTML = source.innerHTML;
    }

    updateElementOuter(selector, html) {
        const destination = this.container.querySelector(selector);
        const source = html.querySelector(selector);
        if (source && destination) destination.outerHTML = source.outerHTML;
    }

    //Update media en fonction du variant sélectionné si pas de slider thumbnail
    updateMedia() {
        if (this.currentVariant.featured_media != null) {
            var allMainMedia = document.querySelectorAll(".mm-product-medias .splide__slide");
            var variant_media_id = this.currentVariant.featured_media.id;
            allMainMedia.forEach((media) => {
                if (media.dataset.id != null && parseInt(media.dataset.id) == variant_media_id) {
                    var pagination = document.querySelectorAll(".mm-product-medias .splide__pagination li")[parseInt(media.dataset.index)];
                    pagination.querySelector("button").click();
                }
            });
        }
    }

    // Mise à jour des images des variants
    updateImagesVariant() {
        var allMainMedia = document.querySelectorAll(".main-slider-variant");
        allMainMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
        var allThumbnailMedia = document.querySelectorAll(".thumbnail-slider-variant");
        allThumbnailMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
    }
}
customElements.define("variant-selector", VariantSelector);

// Custom element for product recommendations
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch((e) => {
					console.error(e);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
	}
}

customElements.define('product-recommendations', ProductRecommendations);